export const API_URL = process.env.REACT_APP_BACKEND_URL
export const CDN_URL = process.env.REACT_APP_CDN_URL

export const MAX_REFRESH_SESSION_AWAITING = 15 * 60 * 1000 // 15 min

export const READ_PERCENT_SEND_INTERVAL = 4000 // 4 sec
export const READ_PERCENT_ERROR_MARGIN = 0